import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTheme } from '@mui/material/styles';

import ReactQuill from 'react-quill';

import getI18nService from '../../i18n/i18n';

const modules = {
  toolbar: false,
  clipboard: {
    matchVisual: false,
  },
};

const i18n = getI18nService();
const TermsAndConditions = props => {
  const { editorHtml, withClose, onClose } = props;

  const theme = useTheme();

  return (
    <Box
      id="test_guest_passThrough"
      sx={{
        height: 350,
        overflow: 'auto',
        borderRadius: 2,
        bgcolor: 'background.paper',
        color: 'white',
        position: 'relative',
        paddingBottom: 1,
        paddingTop: 1,
      }}
    >
      {withClose && (
        <Tooltip title={i18n.t('Vocabulary.doneReading')}>
          <IconButton
            id="test_guest_passThrough_doneReadBtn"
            sx={{ position: 'absolute', bottom: 0, right: 0, zIndex: 99 }}
            aria-label="delete"
            // size="small"
            onClick={onClose}
            color="primary"
          >
            <CheckCircleOutlineIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}
      <Box
        id="test_guest_termsContainer"
        sx={{
          height: '100%',
          overflow: 'auto',
        }}
      >
        <ReactQuill
          style={{ padding: '8px', borderRadius: '8px', flexGrow: 1, color: theme.palette.text.primary }}
          readOnly
          value={editorHtml}
          modules={modules}
          bounds={'.app'}
          placeholder="Start typing"
        />
      </Box>
    </Box>
  );
};

TermsAndConditions.propTypes = {
  editorHtml: PropTypes.string,
  onClose: PropTypes.func,
  withClose: PropTypes.bool,
};

TermsAndConditions.defaultProps = {
  editorHtml: '',
  withClose: false,
  onClose: () => {},
};

export default TermsAndConditions;
